import { logWrapper } from '../utils';

function additionalFieldModelDirectiveFactory(runtimeConstant) {
  function run() {
    try {
      return {
        restrict: 'A',
        require: ['ngModel'],
        link: function (scope, el, attr, controllers) {
          scope.variableName = angular.copy(attr.ngModel); // Salvando o nome da variável
          var controller = controllers[0];

          // Define valor inicial com base no additionalField
          scope[attr.ngModel] = scope.$parent.additionalField(attr.additionalFieldModel);

          // Atualiza o ngModel se o additionalField mudar
          scope.$watch('additionalField(' + attr.additionalFieldModel + ')', function (newValue, oldValue) {
            if (newValue !== undefined && newValue !== oldValue) {
              scope[attr.ngModel] = newValue;
              controller.$setViewValue(newValue, 'changed');
              controller.$render();
            }
          });

          // Atualiza o additionalField se o ngModel mudar
          scope.$watch(attr.ngModel, function (newValue, oldValue) {
            var current = scope.$parent.additionalField(attr.additionalFieldModel);
            if (newValue !== undefined && newValue !== oldValue && newValue !== current) {
              scope.$parent.additionalField(attr.additionalFieldModel, newValue);
            }
          });
        },
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const additionalFieldModelDirective = ['runtimeConstant', additionalFieldModelDirectiveFactory];
